import { render, staticRenderFns } from "./LaboratoryDetailCardstack.vue?vue&type=template&id=38ede1b6"
import script from "./LaboratoryDetailCardstack.vue?vue&type=script&lang=js"
export * from "./LaboratoryDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports